export const tableschema5 = {
    name_table: 'Розділ V. Відомості про матеріально-технічну базу закладу дошкільної освіти кінець звітного року(Державна статистика)',
    titles:[
        "Проєктна потужність закладу, місць",
        "Чи здається частина площі в оренду (необхідне позначити 1 або 2) 1 - так; 2 - ні",
        "Тип приміщень закладу 1 - власні; 2 - орендовані; 3 - частково орендовані",
        "Чи є в закладі: (рядки 5030–5070; 5090–5130 необхідне позначити 1 або 2) Власна територія для організації прогулянок на свіжому повітрі1 - так; 2 - ні",
        "Музична зала 1 - так; 2 - ні",
        "Фізкультурна зала 1 - так; 2 - ні",
        "Ресурсна кімната 1 - так; 2 - ні",
        "Басейн 1 - так; 2 - ні",
        "Опалення 1 - централізоване або індивідуальне опалення; 2 - пічне",
        "Каналізація 1 - так; 2 - ні",
        "Водогін 1 - так; 2 - ні",
        "з гарячою водою 1 - так; 2 - ні",
        "Пандуси та поручні 1 - так; 2 - ні",
        "Ліфти (підйомники) 1 - так; 2 - ні",
        "Спеціально обладнані туалетні кімнати для осіб з інвалідністю 1 - так; 2 - ні",
        "Кількість поверхів в основній будівлі закладу, од",
        "До якого поверху є безперешкодний доступ осіб з інвалідністю 1 - перший; 2 - другий; 3 - третій",
        "Кількість окремих будівель, од",
        "з них потребують капітального ремонту",
        "перебувають в аварійному стані"
      ],
      parts:[
          {title: "Кількісне значення/обране значення", subtitle: "", fields:[
            "BD5000",
            "BD5010",
            "BD5020",
            "BD5030",
            "BD5040",
            "BD5050",
            "BD5060",
            "BD5070",
            "BD5080",
            "BD5090",
            "BD5100",
            "BD5101",
            "BD5110",
            "BD5120",
            "BD5130",
            "BD5140",
            "BD5150",
            "BD5160",
            "BD5161",
            "BD5162"
          ]}
      ],
      shorts:{
          titles:[
            "5000",
            "5010",
            "5020",
            "5030",
            "5040",
            "5050",
            "5060",
            "5070",
            "5080",
            "5090",
            "5100",
            "5101",
            "5110",
            "5120",
            "5130",
            "5140",
            "5150",
            "5160",
            "5161",
            "5162"
          ],
          parts:[
              "1"
          ],
          type:{
              enum: [
                  "BD5010",
                  "BD5020",
                  "BD5030",
                  "BD5040",
                  "BD5050",
                  "BD5060",
                  "BD5070",
                  "BD5080",
                  "BD5090",
                  "BD5100",
                  "BD5101",
                  "BD5110",
                  "BD5120",
                  "BD5130",
                  "BD5150"
              ],
              aver:[
                  "5140"
              ]
          }
      }
};